import { energyApi } from "utilities/Axios";
import { getExtractedPath } from "utilities/extractedPath";

const extractedPath = getExtractedPath();

export const getAllDataSources = () => {
  return energyApi.get(`DatasourceMeta/GetAllDatasourceMeta${extractedPath}`);
};